import useI18n from '@i18n';

export interface ISidebarProps {
    config: {
        key: string;
        link: string;
    }[];
}

const Sidebar: React.FC<ISidebarProps> = ({ config }) => {
    const { t } = useI18n('Offers');

    return (
        <div className="flex-col hidden bg-white rounded-[6px] p-[16px] lg:flex">
            {Array.isArray(config)
                ? config.map(({ key, link }) => {
                      return (
                          <a
                              className="w-full p-2 cursor-pointer max-w-[296px] rounded-[6px] text-[14px] text-blueGray-500 hover:bg-blueGray-100 hover:text-blueGray-800 active:bg-blueGray-100 active:text-blueGray-800 lg:max-w-full"
                              href={`#${link}`}
                              key={link}
                          >
                              {t(key)}
                          </a>
                      );
                  })
                : null}
        </div>
    );
};

export default Sidebar;
